import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, LAYOUT, TYPOGRAPHY } from '../constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.content}>
          {/* Brand Section */}
          <div style={styles.brandSection}>
            <h3 style={styles.brandName}>Redbird Markets</h3>
            <p style={styles.brandDescription}>
              The official marketplace for Illinois State University students, faculty, and staff.
            </p>
          </div>

          {/* Links Sections */}
          <div style={styles.linksGrid}>
            <div style={styles.linkColumn}>
              <h4 style={styles.columnTitle}>Platform</h4>
              <ul style={styles.linkList}>
                <li><button onClick={() => navigate('/how-it-works')} style={styles.linkButton}>How it Works</button></li>
                <li><button onClick={() => navigate('/safety-guidelines')} style={styles.linkButton}>Safety Guidelines</button></li>
                <li><button onClick={() => navigate('/seller-resources')} style={styles.linkButton}>Seller Resources</button></li>
                <li><button onClick={() => navigate('/faq')} style={styles.linkButton}>FAQ</button></li>
              </ul>
            </div>

            <div style={styles.linkColumn}>
              <h4 style={styles.columnTitle}>Legal</h4>
              <ul style={styles.linkList}>
                <li><button onClick={() => navigate('/terms-of-service')} style={styles.linkButton}>Terms of Service</button></li>
                <li><button onClick={() => navigate('/privacy-policy')} style={styles.linkButton}>Privacy Policy</button></li>
                <li><button onClick={() => navigate('/community-guidelines')} style={styles.linkButton}>Community Guidelines</button></li>
                <li><button onClick={() => navigate('/dispute-resolution')} style={styles.linkButton}>Dispute Resolution</button></li>
              </ul>
            </div>

            <div style={styles.linkColumn}>
              <h4 style={styles.columnTitle}>Support</h4>
              <ul style={styles.linkList}>
                <li><button onClick={() => navigate('/help-center')} style={styles.linkButton}>Help Center</button></li>
                <li><button onClick={() => navigate('/contact-us')} style={styles.linkButton}>Contact Us</button></li>
                <li><button onClick={() => navigate('/report-issue')} style={styles.linkButton}>Report Issue</button></li>
                <li><button onClick={() => navigate('/accessibility')} style={styles.linkButton}>Accessibility</button></li>
              </ul>
            </div>

            <div style={styles.linkColumn}>
              <h4 style={styles.columnTitle}>Community</h4>
              <ul style={styles.linkList}>
                <li><a href="https://illinoisstate.edu" target="_blank" rel="noopener noreferrer" style={styles.link}>ISU Website</a></li>
                <li><button onClick={() => navigate('/about-us')} style={styles.linkButton}>About Us</button></li>
                <li><button onClick={() => navigate('/partnerships')} style={styles.linkButton}>Partnerships</button></li>
                <li><button onClick={() => navigate('/social-media')} style={styles.linkButton}>Social Media</button></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={styles.bottomSection}>
          <div style={styles.bottomContent}>
            <p style={styles.copyright}>
              © {currentYear} Redbird Markets — Founded and developed by students of Illinois State University.
            </p>
            <p style={styles.disclaimer}>
              Redbird Markets is an independent student initiative. It is not an official ISU service.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: COLORS.secondary,
    color: COLORS.text.onRed,
    marginTop: 'auto',
    paddingTop: LAYOUT.spacing.xxxl,
    paddingBottom: LAYOUT.spacing.lg,
  },
  container: {
    maxWidth: LAYOUT.maxWidth,
    margin: '0 auto',
    padding: `0 ${LAYOUT.containerPadding}`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.xl,
  },
  brandSection: {
    marginBottom: LAYOUT.spacing.lg,
  },
  brandName: {
    ...TYPOGRAPHY.heading2,
    color: COLORS.white,
    marginBottom: LAYOUT.spacing.sm,
  },
  brandDescription: {
    ...TYPOGRAPHY.body,
    color: COLORS.gray,
    maxWidth: '400px',
    marginBottom: 0,
  },
  linksGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: LAYOUT.spacing.xl,
    marginBottom: LAYOUT.spacing.xl,
  },
  linkColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  columnTitle: {
    ...TYPOGRAPHY.heading3,
    color: COLORS.white,
    fontSize: '1.125rem',
    marginBottom: LAYOUT.spacing.md,
  },
  linkList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.sm,
  },
  link: {
    color: COLORS.gray,
    textDecoration: 'none',
    fontSize: '0.875rem',
    lineHeight: '1.5',
    transition: 'color 0.2s ease',
    cursor: 'pointer',
  },
  linkButton: {
    color: COLORS.gray,
    background: 'none',
    border: 'none',
    fontSize: '0.875rem',
    lineHeight: '1.5',
    transition: 'color 0.2s ease',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left',
    width: '100%',
  },
  bottomSection: {
    borderTop: `1px solid ${COLORS.grayDark}`,
    paddingTop: LAYOUT.spacing.lg,
    marginTop: LAYOUT.spacing.xl,
  },
  bottomContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: LAYOUT.spacing.sm,
    textAlign: 'center',
  },
  copyright: {
    ...TYPOGRAPHY.caption,
    color: COLORS.gray,
    marginBottom: 0,
  },
  disclaimer: {
    ...TYPOGRAPHY.caption,
    color: COLORS.grayDark,
    fontSize: '0.75rem',
    marginBottom: 0,
  },
};

// Add hover styles
const linkHoverStyle = `
  .footer-link:hover {
    color: ${COLORS.white} !important;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = linkHoverStyle;
  document.head.appendChild(styleElement);
}

export default Footer;